var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#24ae5f",
    opacity: 1,
    "data-original": "#f16062",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.19 17.88H14.81c-2.06 0-3.74 1.68-3.74 3.74V42.4c0 2.06 1.68 3.74 3.74 3.74h34.38c2.06 0 3.74-1.68 3.74-3.74V21.61c0-2.06-1.68-3.73-3.74-3.73zm1.68 24.51c0 .93-.75 1.68-1.68 1.68H14.81c-.92 0-1.68-.75-1.68-1.68V21.61c0-.92.75-1.68 1.68-1.68h34.38c.93 0 1.68.75 1.68 1.68z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 35.7h10.08V24.15H16.9zm2.06-9.49h5.96v7.43h-5.96zM33.88 30.97h9.14v2.06h-9.14zM33.88 36.14h9.14v2.06h-9.14z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentity);
export default __webpack_public_path__ + "static/media/identity.c66ffdb9652cff32dbed37d20a9117cb.svg";
export { ForwardRef as ReactComponent };